import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

const MAX_REASONABLE_AGE = 120
const DATE_FORMAT = 'DD.MM.YYYY'

const isValidDateString = (input: string): boolean => {
  if (!input || typeof input !== 'string') return false
  const date = dayjs(input, DATE_FORMAT, true)
  return date.isValid() && !date.isAfter(dayjs())
}

const calculateAge = (input: string): number | null => {
  if (!isValidDateString(input)) return null
  const today = dayjs()
  const birthdate = dayjs(input, DATE_FORMAT)
  return today.diff(birthdate, 'years')
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      isLegalAge: (date: string, legalAge: number) => {
        const age = calculateAge(date)
        if (age === null) return false
        return age >= legalAge
      },

      isBelowMaxAge: (date: string) => {
        const age = calculateAge(date)
        if (age === null) return false
        return age < MAX_REASONABLE_AGE
      },
      formatDateToYYYYMMDD: (d: string) =>
        dayjs(d, DATE_FORMAT).format('YYYY-MM-DD'),
    },
  }
})
